
import * as actions_assets from 'actions/assets-actions';
import * as actions_inventory from 'actions/inventory-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect } from 'react';
import _ from 'lodash';
import { Dropdown } from 'react-bootstrap';
import { Avatar, Ibox, ModalAlert } from 'enspire-manager-framework';
import { PERMISSIONS } from 'components/constants';
import { Table } from 'em-table';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { imageSize } from 'components/common/toolbox';

const StockPartsTab = (props) => {
    
    const seg = 3;

    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
	const routeLocation = useLocation();

    const assetTypes = useSelector((store) => store.settings.settings_asset_types);
    const assets = useSelector((store) => store.assets);
    const categories = useSelector((store) => store.settings.settings_parts_categories);
    const inventory = useSelector((store) => store.inventory.inventory);
    const user_permissions = useSelector(store => store.users?.user_permissions);
    
    const asset = assets.asset;

    /* Effects --------------------------*/

    useEffect(() => {
        dispatch(actions_inventory.getAssetStockParts(params.handle, asset?.stockPartIds));
    }, [asset?.stockPartIds]);

    /* ----------------------------------*/

    /* Handlers --------------------------*/

    const confirmDelete = (item) => {
        ModalAlert({
            title: 'Are you sure?',
            text: "The Stock Part will be removed from this Asset",
            icon: 'warning',
            show_cancel: true,
            confirm_color: '#8FBC8B',
            confirm_text: 'Yes, remove it!',
            callback_success: () => handleDelete(item),
        });
    };

    const handleDelete = (item) => { 
        dispatch(actions_assets.saveStockPartToAsset(params.handle, params.asset_id, item.id, true));
    };

    const openForm = (assetTypeId) => {
		let location = toolbox.modifyPath(routeLocation.pathname, seg, "inventory/" + assetTypeId + '/stock-part-form/0', seg+3);
		history.push({ pathname: location });
    }

    /* Constants --------------------------*/

    const data = inventory?.map((stock) => {
        let category = _.find(categories, { id: stock?.categoryIds?.[0] })?.name;
        return ({ ...stock,
            category: category,
            image: <Avatar className="mx-auto my-n2"
                color="white"
                bgColor="saddleBrown"
                size={55}
                fontSize={'20px'}
                name={stock.name}
                image={imageSize(stock.imageUrl, 'sm')}
                imageWidth={60}
                border="4px solid white"
                role={ (stock.imageUrl) ? "button" : null }
            />
        });
    });
    const columns = [
        { name: "Id", field: "id", width: 15 },
        { name: "Part Number", field: "partNumber", width: 30 },
        { name: "Name", field: "name", width: 55 },
        { name: "Description", field: "description" },
    ];

    const segments = (props.source == 'assets') ? seg+7 : seg+5;

    const vendorButton =  <Dropdown className="d-inline mr-lg-2 mb-2 mr-n2 pull-right">
        <Dropdown.Toggle variant="primary" size="sm">
            + Stock Part &nbsp;
        </Dropdown.Toggle>

        <Dropdown.Menu>
            {
                assetTypes.map((type, index) => <Dropdown.Item key={ type.id } eventKey={ index } onClick={()=>{ openForm(type.id)  }}>{ type.value }</Dropdown.Item>)
            }
        </Dropdown.Menu>
    </Dropdown>


    return (
        <Ibox title={((props.source == 'assets') ? 'Linked ' : '') + 'Stock Parts'} 
            jsx={ (props.source != 'assets') ? vendorButton : null }
            button={ (props.source == 'assets') ? '+ Link Part' : null }
            button_in_ibox={true}
            button_callback={() => {
                let location = toolbox.modifyPath(props.location.pathname, seg+7, 'add-stock-parts', seg+7);
                props.history.push({ pathname: location });
            }}
            button_disabled={ !user_permissions[PERMISSIONS.ASSETS_EDIT.key] }
        >
            <Table
                data={data}
                columns={columns}
                click_callback={(asset) => {
                    // toolbox.listLink(history, props.location.pathname, segments, asset.id + "/form/0", "assets", segments + 2)
                }}
                second_line={'description'}
                second_line_clamp={ 2 }
                image={'image'}
                imageWidth={55}
                group_by={{ fields: ['category'], direction: ['asc'] }}
                delete={true}
                on_delete={confirmDelete}
                highlight_search={true}
                limit={10}
                show_search={true}
            >
            </Table>
        </Ibox>
    );
};

export default StockPartsTab;